// @i18n-ignore-file
export const LOCAL_STORAGE_CHECKOUT_OBJ_KEY = 'quince::checkout::object'
export const LOCAL_STORAGE_CHECKOUT_ID_KEY = 'checkout::lastbrand'
